import {createContext} from 'react';

const SiteLabelContext = createContext();

export default SiteLabelContext;